<template>
  <Container class="flex flex-col items-center">
    <div class="flex flex-col p-4">
      <div
        v-for="(item, index) in data.cards"
        :key="item?.title || index"
        class="mb-11 border-b border-blue-hover pb-11 last:border-none lg:flex lg:items-center"
      >
        <div class="lg:w-full lg:max-w-[50%]">
          <SubTitle v-if="item?.subtitle" class="text-blue">
            {{ item?.subtitle }}
          </SubTitle>
          <Title
            v-if="item?.title"
            :custom-style="twMerge('mb-6 mt-0.5 lg:max-w-[75%]', useDarkMode ? 'text-white' : '')"
          >
            {{ item?.title }}
          </Title>
        </div>
        <div>
          <div
            v-if="item?.copy"
            :class="
              twMerge(
                'custom-list prose lg:prose-lg prose-a:text-blue prose-a:no-underline hover:prose-a:text-blue-dark font-sans text-base leading-[21px] lg:text-xl lg:leading-[26px]',
                useDarkMode ? 'prose-p:text-white prose-ul:text-white' : '',
              )
            "
            v-html="item?.copy"
          />
          <LinkSecondary
            v-if="item?.link"
            :title="item?.link?.title"
            :link="item.link.url"
            :external="item.link?.type === 'ext'"
            :type="'blue'"
            class="mt-5"
          />
        </div>
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
// Sibling: packages/astro-ui/src/components/DynamicBlocks/TitleTextBlock.astro
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import Container from '../atoms/Container.vue'
import LinkSecondary from '../atoms/LinkSecondary.vue'
import type { ICardData } from '../../types'
import { computed, inject, ref, type Ref } from 'vue'
import { twMerge } from 'tailwind-merge'

export interface ITitleTextBlock {
  id: string
  cards: ICardData[]
}

interface Props {
  data: ITitleTextBlock
}

defineProps<Props>()

const settings = inject<Ref<string[]>>('settings', ref([]))
const useDarkMode = computed(() => settings.value?.includes('dark_theme') ?? false)
</script>
